module.exports = __webpack_public_path__ + "static/media/versace-flame-big.120a3d14.png";